import { useEffect, useState } from "react";
import { getContentPlacesApis } from "../apis/ContentApis";
import { useUserHooks } from "./useUserHooks";
import { getAllUserCommercial_Api } from "../apis/CommercialApis";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { setAllEventsData, setAllUserCommercialData, setUser } from "../redux/action";
import { GetMyEvents, getAllEventsApi } from "../apis/EventsApis";

export const useUserHomeHooks = () => {
  //all hooks
 
  const { user_redux } = useUserHooks();

  //all redux
  const dispatch = useDispatch();
  //all local states

  const [allPlacesData, setAllPlacesData] = useState([]);
  const [userLocation, setUserLocation] = useState({});
 const allEventsData=useSelector((s)=>s?.ALLEventsData??{},shallowEqual);
 console.log("All-events-data",allEventsData)
 const normalEvents=allEventsData?.events?.map((i)=>({
  ...(i??{}),
  lat:i?.location?.coordinates?.lat,
  lng:i?.location?.coordinates?.lng
}));
  const [error, setError] = useState(null);

  //useEffect

  // useEffect(() => {
  //   fetchLocation();
  // }, []);


 // api for commercials

 const GetUserCommercialApi = async () => {
  try {
    let response = await getAllUserCommercial_Api();
    if (response?.success) {
      console.log("Commercials fetched.......",response);
      dispatch(setAllUserCommercialData(response?.data?.commercials));
    }
  } catch (e) {
    console.log("errror  rrrrr", e);
  }
};

const getAllPlacesApiCalled = async () => {
  let response = await getContentPlacesApis(
    "",
    user_redux?.location?.coordinates[0],
    user_redux?.location?.coordinates[1],
    500
  );
  if (response?.places) {
    setAllPlacesData(response?.places);
  }
};


  useEffect(() => {
    if (user_redux?.location?.coordinates[0] && user_redux?.location?.coordinates[1]) {
      getAllPlacesApiCalled();
      GetUserCommercialApi();
      if(userLocation?.latitude&&userLocation?.longitude)
      {
        console.log("Sending coordinates to events get api",userLocation);
        getAllEventsApi(userLocation?.latitude,
          userLocation?.longitude,2000,{},
          "").then((r)=>{
           
            dispatch(setAllEventsData(r?.data?.data));
          });
      }
    }
  }, [user_redux?.location?.coordinates,userLocation]);



  //all functions

  // const fetchLocation = async () => {
  //   try {
  //     const location = await getLocation();
  //     if (location?.location) {
  //       setUserLocation({
  //         lat: location?.location?.latitude,
  //         lng: location?.location?.longitude,
  //       });
  //     }
  //   } catch (error) {
  //     console.error("Failed to get location:", error);
  //   }
  // };
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setUserLocation({
            latitude: position?.coords?.latitude,
            longitude: position?.coords?.longitude,
          });
          dispatch(setUser({
            ...user_redux,
            location: {
              ...user_redux.location,
              coordinates: [position?.coords?.latitude, position?.coords?.longitude]
            }
          }))
        },
        (err) => {
          setError(err.message);
        }
      );
    } else {
      setError('Geolocation is not supported by this browser.');
    }
  }, []);

 

 

  return {
    //all local states
    userLocation,
    allPlacesData,
    normalEvents,
  

    //all hooks
    user_redux,
  };
};
